import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Plus, MoreVertical, Eye, Pencil, Trash2 } from 'lucide-react';
import { getStatusColor } from '../../lib/utils';

export function AccountsTab({
  accounts,
  onCreateAccount,
  onImpersonate,
  onEdit,
  onUpdateStatus,
  onDelete,
  onRunBackfill,
}) {
  return (
    <Card className="border-slate-200">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg">All Accounts</CardTitle>
        <div className="flex items-center gap-2">
          <Button 
            onClick={onRunBackfill} 
            variant="outline"
            className="border-orange-200 text-orange-600 hover:bg-orange-50"
            data-testid="run-backfill-btn"
          >
            Run Backfill
          </Button>
          <Button onClick={onCreateAccount} data-testid="create-account-btn">
            <Plus className="mr-2 h-4 w-4" />
            Create Account
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="data-table">
            <thead>
              <tr>
                <th>Brand</th>
                <th>Owner</th>
                <th>Plan</th>
                <th>Status</th>
                <th>Restaurants</th>
                <th>Staff</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((account) => (
                <tr key={account.id} data-testid={`account-${account.id}`}>
                  <td className="font-medium text-slate-900">{account.brand_name}</td>
                  <td>
                    <div>
                      <p className="text-slate-900">{account.owner_name}</p>
                      <p className="text-xs text-slate-500">{account.owner_email}</p>
                    </div>
                  </td>
                  <td className="capitalize">{account.plan_type}</td>
                  <td>
                    <span className={`status-badge ${getStatusColor(account.status)}`}>
                      {account.status}
                    </span>
                  </td>
                  <td>{account.restaurant_count}</td>
                  <td>{account.staff_count}</td>
                  <td>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="sm">
                          <MoreVertical size={16} />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end">
                        <DropdownMenuItem
                          data-testid={`impersonate-${account.id}`}
                          onClick={() => onImpersonate(account.owner_user_id)}
                        >
                          <Eye className="mr-2 h-4 w-4" />
                          Impersonate
                        </DropdownMenuItem>
                        <DropdownMenuItem
                          data-testid={`edit-account-${account.id}`}
                          onClick={() => onEdit(account)}
                        >
                          <Pencil className="mr-2 h-4 w-4" />
                          Edit
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={() => onUpdateStatus(account.id, 'active')}>
                          Set Active
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={() => onUpdateStatus(account.id, 'free')}>
                          Set Free
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={() => onUpdateStatus(account.id, 'canceled')}>
                          Set Canceled
                        </DropdownMenuItem>
                        <DropdownMenuItem
                          data-testid={`delete-account-${account.id}`}
                          onClick={() => onDelete(account)}
                          className="text-red-600 focus:text-red-600"
                        >
                          <Trash2 className="mr-2 h-4 w-4" />
                          Delete Account
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
